import { styled } from '../jss-style';

import dropdownStyle from './dropdown';

const useDropdownStyle = styled(dropdownStyle, 'dropdown');

export { dropdownStyle, useDropdownStyle };

export default useDropdownStyle;
